import Vue from 'vue'

// POI
function getPOIById (poiId) {
  return Vue.axios.get(`/poi/${poiId}`)
}

function getPOIs (collegeId, options) {
  let params = ''

  for (let prop in options) {
    if (options[prop]) {
      params = `${params}${prop}=${options[prop]}&`
    }
  }

  return Vue.axios.get(`/college/${collegeId}/poi?${params}`)
}

function getCategories (collegeId) {
  return Vue.axios.get(`/college/${collegeId}/category`)
}

function getTours (collegeId) {
  return Vue.axios.get(`/college/${collegeId}/tour`)
}

function getClosestPOIs (collegeId, lat, lon, options) {
  let params = ''

  for (let prop in options) {
    if (options[prop]) {
      params = `${params}${prop}=${options[prop]}&`
    }
  }

  return Vue.axios.get(`/college/${collegeId}/poi/point?lat=${lat}&lon=${lon}&${params}`)
}

function getPersonalizedTourById (student, tourId) {
  return Vue.axios.get(`/student/${student}/tour?tour=${tourId}`)
}

function savePersonalizedTour (student, poiIds) {
  return Vue.axios.post(`/student/${student}/tour`, { poiIds: poiIds })
}

// Student & Notes
function createStudent () {
  return Vue.axios.post('/student/create')
}

function getStudentNotes (student) {
  return Vue.axios.get(`/student/${student}`)
}

function updateStudentNote (student, poiId, text) {
  return Vue.axios.post(`/student/${student}/note/${poiId}`, { 'text': text })
}

function trackPOIVisit (student, poiId) {
  return Vue.axios.post(`/student/${student}/visit/${poiId}`)
}

export default {
  createStudent,
  getCategories,
  getClosestPOIs,
  getPersonalizedTourById,
  savePersonalizedTour,
  getPOIById,
  getPOIs,
  getStudentNotes,
  getTours,
  trackPOIVisit,
  updateStudentNote
}
